

// *************************** Import CSS *************************** //

import '@styles/main.scss';
import "./wc2024-feature.css";

// *************************************************** Insert Winter Camp 2024 Feature **************************************************** //

class WC2024Feature extends HTMLElement {
  connectedCallback() {
    this.innerHTML = `

    <div class="wc2024-story-container container d-flex justify-content-center mx-auto px-0">

      <div class="wc2024-story-div row col-12 mx-auto px-0">
  
      <div class="tape-top-right"></div>
      <div class="tape-bottom-left"></div>

      <!-- ***************************** BEGIN: Photos & Text ****************************** -->

      <div class="container px-0">

        <!-- ************************ BEGIN: Title Row ************************ -->

        <div class="row col-12 d-flex justify-content-center mx-auto mt-1 mb-2 px-0">

          <div class="wc24-badge col-4 col-sm-3 col-lg-2 mx-auto mt-2 mb-1">
            <div class="col-12 badge badge-dark-purple mx-auto">
              <img src="assets/icons/white-brackets.png" height="30px" loading="lazy" alt="badge with html brackets">
            </div>
          </div>

          <div class="wc24-title1 col-12">
            <p class="wc24-title-text font-oswald bold text-center">
              Winter Camp 2024
            </p>
          </div>

          <div class="wc24-title2 col-12">
            <p class="wc24-title-text font-oswald bold text-center">
              Coding for the Community
            </p>
          </div>

        </div>

        <!-- ************************ END: Title Row ************************ -->


        <!-- ************************ BEGIN: ROW 1 ************************ -->

        <div class="wc24-row1 row col-12 d-flex justify-content-center mx-auto mt-3 mt-xl-4 px-0">

          <!-- BEGIN: Row 1: 2 Pics -->

          <div class="wc24-img-group1-div row col-12  col-xxl-7 d-flex justify-content-center mx-auto px-0">

            <!-- Begin: Pic 1 - News Story -->

            <div class="wc24-img1-div col-12 col-xxl-5 drop-shadow-2 px-0">
              <div class="wc24-image bg-dark-purple py-2">
                <a href="https://www.savannahnow.com/story/news/education/2025/01/12/girls-code-savannah-offers-real-world-training-for-tech-industry-careers/77355458007/" target="_blank">
                  <img class="wc2024-img-1" src="assets/winter-camp-2024/wc24-full-story/7-press/wc24-sav-morn-news-article-1.jpg" height="200" loading="lazy" alt="pics of girls coding during winter camp">
                </a>
              </div>
            </div>

            <!-- End: Pic 1 -->

            <!-- Begin: Pic 2 - Website -->

            <div class="wc24-img2-div col-12 col-xxl-7 text-center mt-0 mt-md-0 px-0 mx-0">
              <img class="wc2024-img-2 drop-shadow-2" src="assets/winter-camp-2024/wc24-full-story/0-top-pics/gcs-wc2024-savym-website.png" height="300" loading="lazy" alt="SAV Youth Mentoring website screenshot">
            </div>

            <!-- End: Pic 2 -->

          </div>

          <!-- END: Row 1: 2 Pics -->

          <!-- BEGIN: Row 1: Text -->

          <div class="wc24-text-group1-div row col-12 col-lg-9 col-xl-10 col-xxl-5 pt-2 mx-auto">

            <p class="wc24-text-group1 wc24-story-text text-start col-12 col-sm-10 col-lg-12 col-xxl-12 pt-2">
              <span class="wc24-intro-text font-oswald bold blue-underline">Girls Code Savannah evolved to the next level</span> for Winter Camp 2024. Our students acted as one large tech team and 
              put their real-world coding skills on display to build a public website that meets a community need.
            </p>
          
            <p class="wc24-text-group2 wc24-story-text text-start col-12 col-sm-10 col-lg-12 col-xxl-12 pt-lg-2">
              The new website <a class="text-brighter-blue serif-heading text-size-h3 bold letter-spacing-1px" href="https://www.savyouthmentoring.org" 
              target="_blank">SAVYouthMentoring.org</a> 
              helps local youth-focused nonprofits & organizations disseminate information about their programs & services, advertise their events, 
              and match with local volunteers seeking to make a difference in the lives of Greater Savannah's youth.
            </p>

          </div>

          <!-- END: Row 1: Text -->

        </div>

        <!-- ************************ END: ROW 1 ************************ -->


        <!-- ************************ BEGIN: ROW 2 ************************ -->

        <div class="wc24-row2 row col-12 d-flex justify-content-center mx-auto mt-0 mt-xl-4 px-0">

          <!-- BEGIN: Row 2: 3 Pics -->

          <div class="wc24-img-group2-div row col-12 col-lg-7 col-xl-11 col-xxl-7 justify-content-center mx-auto px-0 ps-xl-2">

            <!-- Begin: Row 2 - Pic 1 - Girls Showing Website -->

              <div class="wc24-img3-div col-10 col-lg-4 col-xl-3 col-xxl-4 drop-shadow-2 mb-2 p-0 px-lg-1">
                <div class="wc24-image-cutout text-center text-lg-start bg-dark-purple p-2">
                  <img class="wc2024-img-3 drop-shadow-2" src="assets/winter-camp-2024/wc24-full-story/5-uiux/wc24-student-showing-website-dev-savmn.jpg" height="200" loading="lazy" alt="pics of girls coding during winter camp">
                </div>
                <div class="circle">*</div>
              </div>

            <!-- End: Row 2 - Pic 1 -->

            <!-- Begin: Row 2 - Pic 2 - Pointing At Website -->

              <div class="wc24-img4-div col-10 col-lg-4 col-xl-3 col-xxl-4 drop-shadow-2 mb-2 p-0 px-sm-2 px-xl-1">
                <div class="wc24-image text-center text-lg-start bg-dark-purple p-2">
                  <img class="wc2024-img-4 drop-shadow-2" src="assets/winter-camp-2024/wc24-full-story/4-graphic-design/wc24-2-girls-coding.jpg" height="200" loading="lazy" alt="pics of girls coding during winter camp">
                </div>
              </div>

            <!-- Begin: Row 2 - Pic 2 -->

            <!-- Begin: Row 2 - Pic 3 - Website Colors -->

              <div class="wc24-img5-div col-10 col-lg-4 col-xl-3 col-xxl-4 drop-shadow-2 mb-2 p-0 px-sm-2 px-xl-1">
                <div class="wc24-image text-center text-lg-start bg-dark-purple p-2">
                  <img class="wc2024-img-5 drop-shadow-2" src="assets/winter-camp-2024/wc24-full-story/4-graphic-design/wc24-color-palette-3.jpg" height="200" loading="lazy" alt="pics of girls coding during winter camp">
                </div>
              </div>

            <!-- Begin: Row 2 - Pic 3 -->

          </div>

          <!-- END: Row 2: 3 Pics -->


          <!-- BEGIN: Row 2: Text -->

          <div class="wc24-text-group2-div row col-12 col-md-6 col-lg-5 col-xl-10 col-xxl-5 mx-auto">

            <p class="wc24-text-group3 wc24-story-text col-12 col-sm-10 col-xl-12 text-start">
              Held January 2nd - 4th at the SW Chatham branch of the 
              <a class="text-brighter-blue serif-heading text-size-h3 bold" href="https://liveoakpl.org/home" target="_blank">Live Oak Public Library</a>, 
              Girls Code Savannah students formed 3 tech sub-teams &mdash; Graphic Design, UI/UX Coding, & Data Engineering &mdash; in order to complete the 
              new website over the first 2 days of camp.
            </p>

            <p class="wc24-text-group4 wc24-story-text col-12 col-sm-10 col-xl-12 text-start">
              What happened on the 3rd day? The website successfully went <span class="bold">LIVE</span>, and we celebrated, of course! 
              Since Winter Camp 2024, the 
              <a class="text-brighter-blue serif-heading text-size-h3 bold" href="https://www.savyouthmentoring.org" target="_blank">website they built</a>
              has been a <b>HUGE SUCCESS</b>!    
            </p>

          </div>

          <!-- END: ROW 2: Text -->

        </div>

        <!-- ************************ END: ROW 2 ************************ -->




      <!-- ************************ BEGIN: ROW 3 ************************ -->

      <div class="wc24-row3 row col-12 d-flex justify-content-center mx-auto mt-0 mt-xl-3 px-0">


      <!-- BEGIN: Row 3: 3 Pics -->

      <div class="wc24-img-group3-div row col-12 col-lg-7 col-xl-11 col-xxl-7 justify-content-center mx-auto px-0 ps-xl-2">

        <!-- Row 3 - Pic 1 - Girls Coding -->

          <div class="wc24-img6-div col-10 col-lg-4 col-xl-3 col-xxl-4 drop-shadow-2 mb-2 p-0 px-xl-1">
            <div class="wc24-image text-center text-lg-start bg-dark-purple p-2">
              <img class="wc2024-img-6 drop-shadow-2" src="assets/winter-camp-2024/wc24-full-story/4-graphic-design/wc24-3-girls-coding.jpg" height="200" loading="lazy" alt="pics of girls coding during winter camp">
            </div>
          </div>

        <!-- Row 3 - Pic 2 - WTOC -->

          <div class="wc24-img7-div col-10 col-lg-4 col-xl-3 col-xxl-4 drop-shadow-2 mb-2 p-0 px-sm-2 px-lg-3 px-xl-1">
            <div class="wc24-image text-center text-lg-start bg-dark-purple p-2">
              <img class="wc2024-img-7 drop-shadow-2" src="assets/press-images/wtoc-morning-break-2025-width.jpg" height="200" loading="lazy" alt="pics of girls coding during winter camp">
            </div>
          </div>

        <!-- Row 3 - Pic 3 - Student Explaining -->

          <div class="wc24-img8-div col-10 col-lg-4 col-xl-3 col-xxl-4 drop-shadow-2 mb-2 p-0 px-sm-2 px-lg-3 px-xl-1">
            <div class="wc24-image-cutout text-center text-lg-start bg-dark-purple p-2">
              <img class="wc2024-img-8 drop-shadow-2" src="assets/winter-camp-2024/wc24-full-story/5-uiux/wc24-student-explaining-code-savmn.jpg" height="200" loading="lazy" alt="pics of girls coding during winter camp">
            </div>
            <div class="circle">*</div>
          </div>

      </div>

      <!-- END: Row 3: 3 Pics -->


      <!-- BEGIN: Row 3: Text -->

      <div class="wc24-text-group3-div row col-12 col-md-6 col-lg-5 col-xl-10 col-xxl-5 mx-auto">

          <p class="wc24-text-group5 wc24-story-text col-12 col-sm-10 col-xl-12 text-start">
            The new website has done exactly what it was intended to do &mdash; make a positive impact in the community. 
            This impact includes more youth-focused organizations joining the <span class="bold">HUB</span>, the launch of the 
            <a class="text-brighter-blue serif-heading text-size-h3 bold" href="https://www.savyouthmentoring.org/podcast" target="_blank">SAV Youth Mentoring HUB Podcast</a>, 
            and more families & youth learning about the supportive services & programs available all around them. Now that's using tech for good!
          </p>

          <p class="wc24-text-group6 wc24-credit-text col-12 col-sm-10 col-lg-8 col-xxl-12 text-start">
            Note: Photos indicated with a bottom-right &ast; were provided by Joseph Schwartzburt/Savannah Morning News. 
            Read the news story <a class="text-brighter-blue serif-heading bold" 
            href="https://www.savannahnow.com/story/news/education/2025/01/12/girls-code-savannah-offers-real-world-training-for-tech-industry-careers/77355458007/" target="_blank">here.</a>
          </p>


      </div>

      <!-- END: Row 3: Text -->

      </div>

      <!-- ************************ END: ROW 3 ************************ -->

    </div>


    <!-- ******************************** END: Photos & Text ********************************* -->
   
    
    <!-- ******************************* BEGIN: Camp Sponsors ******************************** -->

    <div class="col-12 text-center mx-auto mt-0">     

      <div class="col-12 col-sm-10 d-flex justify-content-center mx-auto mt-0 mb-3">
        <p class="wc24-thank-you-text font-oswald bold mx-auto text-center m-2 mt-0">
          &nbsp;Thank You to Our Winter Camp 2024 Supporters &#38; Partners!&nbsp;
        </p>
      </div>

    <!-- BEGIN: Sponsor Logo Section -->
    <div class="row g-3 justify-content-center align-items-center text-center mb-4">

      <!-- 1. Savannah Professional Women for Good -->
      <div class="col-12 col-sm-10 col-tablet-6 col-lg-5 col-xl-4">
        <a href="https://www.arionnacollection.com" target="_blank" class="cta-block d-flex align-items-center justify-content-center p-3 rounded-3">
          <img class="arionna-logo-img img-fluid" src="assets/sponsor-logos/arionna-logo.png" loading="lazy" alt="Arionna Collection logo">
        </a>
      </div>

      <!-- 2. Live Oak Libraries -->
      <div class="col-12 col-sm-10 col-tablet-6 col-lg-5 col-xl-4">
        <a href="https://liveoakpl.org" target="_blank" class="cta-block d-flex align-items-center justify-content-center p-3 rounded-3">
          <img class="fs24-live-oak-img img-fluid" src="assets/sponsor-logos/LOPL/lopl-full-round-logo-2026.png" loading="lazy" alt="live oak libraries logo">
        </a>
      </div>

    </div>
    <!-- END: Sponsor Logo Section -->

  </div>
</div>
<!-- *************** END: Fall 2024 Sponsors ************ -->




    </div>

    <!-- ******************************* END: Camp Sponsors ******************************** -->

    </div>

  </div> <!-- wc2024-story-container -->

  <!-- *********************************** END: Winter Camp 2024 Feature ***************************************** -->

    `
  }
}

// *********************** Define 'extends HTMLElements' Above *********************** //

customElements.define('wc2024-feature', WC2024Feature);
